import React from 'react';

const ProductNotAvailable = (props) => {
    const { expired } = props;

    return (
        <div className="full-message result-message product-not-available">
            <div className="image-warning-container">
                <img className="img-warning" src={require('../assets/warning-512.png')} alt="Icono producto agotado"/>
            </div>
            <h5>
                {(expired) ? 'Producto Expirado' : 'Producto Agotado'}
            </h5>

            <div className="aditional-text">
                <div>Este producto ya no está disponible.</div>
                <div>Contáctese con el comercio.</div>
            </div>
        </div>
    );
}


export default ProductNotAvailable



// WEBPACK FOOTER //
// ./client/components/ProductNotAvailable.js